const ua = window.navigator.userAgent

const isSafari = /^((?!chrome|android).)*safari/i.test(ua)

export { isSafari, ua }
